import { render, staticRenderFns } from "./ManaLayout.vue?vue&type=template&id=7b236bb4&scoped=true&"
import script from "./ManaLayout.vue?vue&type=script&lang=js&"
export * from "./ManaLayout.vue?vue&type=script&lang=js&"
import style0 from "./ManaLayout.vue?vue&type=style&index=0&id=7b236bb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b236bb4",
  null
  
)

export default component.exports